// ─── Estructura académica: qué ve quien NO la gestiona (S0·SEC-1b, 2a-1b) ───
// Crear, editar y borrar departamentos, programas, cursos y períodos es de
// administración, registro y decanato (`useCanManageAcademics` =
// SECTION_MANAGEMENT_ROLES del servidor, que es quien de verdad lo impide).
// Un docente o un mentor llega a estas pantallas para CONSULTAR: el catálogo, la
// malla de un programa, la ficha de un curso. Antes veía lápices, basureros,
// «Editar período», «Configurar materias» y formularios con «Guardar» que el
// servidor rechazaba — un botón que falla se lee como un error del sistema.
// (Visto por Ricardo en la prueba de #737 en staging, 2026-10-24.)

export type StructureKind = 'departments' | 'programs' | 'courses' | 'terms';
export type StructureRowAction = 'edit' | 'delete' | 'view';

/** Acciones de cada fila del catálogo. Programas y cursos tienen ficha propia:
 *  quien no gestiona la puede ABRIR para consultarla («Ver»). */
export function structureRowActions(opts: {
  canManage: boolean;
  kind: StructureKind;
}): StructureRowAction[] {
  if (opts.canManage) return ['edit', 'delete'];
  return opts.kind === 'programs' || opts.kind === 'courses' ? ['view'] : [];
}

/** ¿Lleva la columna «Acciones»? Sin acciones, la columna vacía sobra. */
export function showsActionsColumn(opts: { canManage: boolean; kind: StructureKind }): boolean {
  return structureRowActions(opts).length > 0;
}

export type TermHeaderAction = 'editTerm' | 'configureSubjects';

/** Botones de la cabecera del detalle de un período. */
export function termHeaderActions(opts: { canManage: boolean }): TermHeaderAction[] {
  return opts.canManage ? ['editTerm', 'configureSubjects'] : [];
}

export type ProgramTab = 'general' | 'curriculum' | 'finances' | 'documents';

/** Pestañas del detalle de un programa. Finanzas (aranceles, becas) y
 *  Documentos (requisitos, comité de revisores) son de gestión; General y
 *  Currículo se consultan en solo lectura. El orden NO cambia: las de gestión
 *  van al final, así los índices de las demás se conservan. */
export function programTabs(opts: { canManage: boolean }): ProgramTab[] {
  return opts.canManage
    ? ['general', 'curriculum', 'finances', 'documents']
    : ['general', 'curriculum'];
}

/** ¿El detalle (programa o curso) se puede editar y guardar? */
export function detailEditable(opts: { canManage: boolean }): boolean {
  return opts.canManage;
}
